export default __webpack_public_path__ + "static/media/star_alt.33569880.png";